import React from "react";
import podium from "../assets/images/img-apropos-podium.webp";

export default function AboutSection() {
  return (
	<section id="apropos" className="section">
	  <div className="container about">
		<div className="about-text" data-reveal="left">
		  <h2 className="section-title">À propos</h2>

		  <p>
			Chez <strong>Wolves</strong>, le judo se vit comme une <strong>meute</strong> : on avance ensemble.
			Les anciens guident, les plus jeunes apprennent, et chacun tire l'autre vers le haut.
			Sur le tatami, on forge la <strong>technique</strong>, le <strong>contrôle</strong> et la
			<strong> confiance</strong> dans un cadre respectueux et sécurisé.
		  </p>

		  <p>
			Que tu viennes pour la compétition ou le loisir, tu trouveras ta place : on travaille dur,
			on s'entraide et on progresse à chaque séance.
			<strong> Le cours enfant est disponible dès l'âge de 5 ans.</strong>
		  </p>

		  <ul className="values">
			<li data-reveal="up" data-delay="1"><strong>Respect</strong> – saluer, écouter, protéger ses partenaires.</li>
			<li data-reveal="up" data-delay="2"><strong>Esprit de meute</strong> – entraide, cohésion, responsabilité.</li>
			<li data-reveal="up" data-delay="3"><strong>Discipline</strong> – rigueur, ponctualité, constance.</li>
			<li data-reveal="up" data-delay="4"><strong>Progression</strong> – objectifs clairs, progrès mesurés, humilité.</li>
			<li data-reveal="up" data-delay="5"><strong>Fair-play</strong> – combativité propre, sécurité avant tout.</li>
			<li data-reveal="up" data-delay="6"><strong>Persévérance</strong> – effort continu, dépassement des difficultés.</li>
		  </ul>

		  <blockquote className="about-quote" data-reveal="up">
			« Seul on va vite, <b>ensemble</b> on va plus loin. »
		  </blockquote>
		</div>

		<aside className="about-card" data-reveal="right">
		  <figure className="about-photo">
			<img
			  src={podium}
			  alt="Judokas du club Wolves avec leurs médailles et la coupe, entourés de leurs coachs"
			  loading="lazy"
			/>
			<figcaption>Nos judokas et leurs coachs après un tournoi</figcaption>
		  </figure>

		  <h3>La meute, c'est la force</h3>
		  <p>Un cadre familial, des coachs impliqués, une progression réelle.</p>

		  <div className="stats">
			<div className="stat" data-reveal="scale" data-delay="1">
			  <div className="num">5+</div>
			  <div className="lab">Âge minimum</div>
			</div>
			<div className="stat" data-reveal="scale" data-delay="2">
			  <div className="num">3</div>
			  <div className="lab">Séances / semaine</div>
			</div>
			<div className="stat" data-reveal="scale" data-delay="3">
			  <div className="num">100%</div>
			  <div className="lab">Débutants bienvenus</div>
			</div>
		  </div>

		  <a className="btn-primary w-full" href="#inscription">Essai gratuit</a>
		</aside>
	  </div>
	</section>
  );
}
